export const LIST_ALL_ACTIVITIES = `query ($pageSize: Int, $pageNumber: Int) {
  list_all_activities(page_size: $pageSize, page_number: $pageNumber){
    message
    data {
      _id
      name
      img
      description
      rate
      is_active
      minimum_pax
      maximum_pax
      inclusions
      exclusions
      email
      phone
      billing_mode
    }
    hasMore
  }
}`;

export const ADD_NEW_ACTIVITY = `mutation ($name: String!, $img: String, $description: String, $rate: Float, $minimum_pax: Int, $maximum_pax: Int, $inclusions: String, $exclusions: String, $email: String, $phone: String, $billing_mode: String) {
  add_new_activity(name: $name, img: $img, description: $description, rate: $rate, minimum_pax: $minimum_pax, maximum_pax: $maximum_pax, inclusions: $inclusions, exclusions: $exclusions, email: $email, phone: $phone, billing_mode: $billing_mode) {
    message
  }
}
`;

export const LIST_ACTIVITY_DETAILS = `query ($id: String) {
  list_activity_details(_id: $id){
    message
    data {
      _id
      name
      img
      description
      rate
      is_active
      minimum_pax
      maximum_pax
      inclusions
      exclusions
      email
      phone
      billing_mode
    }
  }
}`;

export const ACTIVATE_ACTIVITY = `mutation ($id: String!) {
  activate_activity(_id: $id){
    message
  }
}`;

export const DELETE_ACTIVITY = `mutation ($id: String!) {
  delete_activity(_id: $id){
    message
  }
}`;

export const UPDATE_ACTIVITY = `mutation ($id: String!, $name: String, $img: String, $description: String, $rate: Float, $minimum_pax: Int, $maximum_pax: Int, $inclusions: String, $exclusions: String, $email: String, $phone: String, $billing_mode: String) {
  update_activity(_id: $id, name: $name, img: $img, description: $description, rate: $rate, minimum_pax: $minimum_pax, maximum_pax: $maximum_pax, inclusions: $inclusions, exclusions: $exclusions, email: $email, phone: $phone, billing_mode: $billing_mode) {
    message
  }
}`;
